async function getQuestions({
  professionSeoName,
  minAnswerCount,
  page,
  size,
  order,
  orderBy,
}) {
  const resp = await this.$axios.get("/questions", {
    params: {
      professionSeoName,
      minAnswerCount,
      page,
      size,
      order,
      orderBy,
    },
  });
  if (resp.status === 200) {
    return resp.data;
  }
  return null;
}

/**
 *
 * @param {string} seoName
 */
async function getCountyBySeoName(seoName) {
  const resp = await this.$axios.get(`/counties/${seoName}`);
  if (resp.status === 200 || resp.status === 301) {
    return resp.data;
  }
  if (resp.status === 404) {
    return null;
  }
  throw new Error("Failed to fetch county by seo name");
}

async function getCities({
  countySeoName,
  minPopulation,
  order,
  orderBy,
} = {}) {
  const resp = await this.$axios.get("/cities", {
    params: {
      countySeoName,
      minPopulation,
      order,
      orderBy,
    },
  });
  if (resp.status === 200) {
    return resp.data;
  }
  console.error("Failed to fetch cities", resp);
  throw new Error("Failed to fetch cities");
}

// JSZK2-2466 This will now return all profession tasks, not only the ones with minimum price
async function getProfessionsWithTasks({ page, size }) {
  const resp = await this.$axios.get("/professions/profession-tasks", {
    params: {
      page,
      size,
    },
  });
  if (resp.status === 200) {
    return resp.data;
  }
  if (resp.status === 404) {
    return null;
  }
  throw new Error("Failed to fetch professions with profession tasks");
}

/**
 * @param {string} seoName
 */
async function getPopularProfessionTasks({
  professionSeoName,
  citySeoName,
  limit,
  minimumProfessionalCount,
  minSearch,
}) {
  const resp = await this.$axios.get("/profession-tasks/popular", {
    params: {
      professionSeoName,
      citySeoName,
      limit,
      minimumProfessionalCount,
      minSearch,
    },
  });
  if (resp.status === 200) {
    return resp.data;
  }
  throw new Error("Failed to fetch popular profession tasks");
}

/**
 * @param {string} keyword
 */
async function searchProfessionTasksByKeyword(keyword) {
  const resp = await this.$axios.get("/profession-tasks/search", {
    params: {
      keyword,
    },
  });
  if (resp.status === 200) {
    return resp.data;
  }
  throw new Error("Failed to search profession tasks");
}

/**
 * @param {string} path
 */
async function getRedirect(path) {
  const resp = await this.$axios.get("/redirect", {
    params: {
      path,
    },
  });

  if (resp.status === 200) {
    return resp.data.location;
  }
  if (resp.status === 404) {
    return null;
  }
  throw new Error("Failed to fetch redirect");
}

async function getAllPriceCalculators() {
  const resp = await this.$axios.get("/price-calculators");
  if (resp.status === 200) {
    return resp.data;
  }
  throw new Error("Failed to fetch price calculators");
}

const useRestClient = (axios) => {
  return {
    cities: {
      get: getCities.bind({ $axios: axios }),
    },
    professions: {
      withTasks: getProfessionsWithTasks.bind({ $axios: axios }),
    },
    counties: {
      bySeoName: getCountyBySeoName.bind({ $axios: axios }),
    },
    questions: {
      get: getQuestions.bind({ $axios: axios }),
    },
    professionTasks: {
      searchByKeyword: searchProfessionTasksByKeyword.bind({ $axios: axios }),
      popularByProfessionSeoName: getPopularProfessionTasks.bind({
        $axios: axios,
      }),
    },
    redirect: {
      get: getRedirect.bind({ $axios: axios }),
    },
    priceCalculators: {
      getAll: getAllPriceCalculators.bind({ $axios: axios }),
    },
  };
};

export default useRestClient;
